import { isUnauthorized, SESSION_QUERY_KEY } from '@frontends/data-access-spg-auth';
import { type ApiError, isApiError } from '@frontends/util-api-errors';
import { MutationCache, type Query, QueryCache, QueryClient } from '@tanstack/react-query';

const MAX_RETRIES = 1;

function isClientError(error: ApiError): boolean {
  const status = error.httpStatus;

  return status !== undefined && status >= 400 && status < 500;
}

function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiError(error) && isClientError(error)) {
    return false;
  }

  return failureCount < MAX_RETRIES;
}

function onUnauthorized(error: unknown): void {
  if (isApiError(error) && isUnauthorized(error)) {
    void queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY });
  }
}

function onQueryError(error: unknown, query: Query<unknown, unknown, unknown>): void {
  if (query.queryKey[0] !== SESSION_QUERY_KEY[0]) {
    onUnauthorized(error);
  }
}

export const queryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache({ onError: onQueryError }),
  mutationCache: new MutationCache({ onError: onUnauthorized }),
  defaultOptions: {
    queries: { retry: shouldRetry, refetchOnWindowFocus: false },
  },
});
